import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import './assets/styles.scss';
import authService from './services/authService.js';

// Importing the CSS file for the toast notifications

const app = createApp(App);

const toastOptions = {
    position: "top-left",
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    rtl: false
};

app.use(Toast, toastOptions);
app.use(router);

// Make authService globally accessible for development/debugging
if (process.env.NODE_ENV === 'development') {
  window.authService = authService;
  // Clear any existing rate limiting on app start in development
  authService.clearRateLimiting();
  console.log('Development mode: Rate limiting cleared on app start');
  
  // Add debugging message listener
  window.addEventListener('message', (event) => {
    if (event.origin !== window.location.origin) return;
    
    if (event.data.type === 'ROUTER_INSPECT') {
      const routerInfo = {
        type: 'ROUTER_INFO',
        currentRoute: router.currentRoute.value.path,
        routes: router.getRoutes().map(r => r.path)
      };
      event.source?.postMessage(routerInfo, event.origin);
    } else if (event.data.type === 'CHECK_ROUTE_GUARDS') {
      // Will be implemented in the router file
      console.log('Route guard check requested');
    } else if (event.data.type === 'ROUTER_PUSH') {
      router.push(event.data.path).catch(err => {
        console.error('Router push failed:', err);
      });
    }
  });
}

app.mount('#app');
